// extracted by mini-css-extract-plugin
export default {"container":"NameContainer_container__ixQci","initial":"NameContainer_initial__TQGMD"};